(function (w, d, $, undefined) {
  // Global namespace
  var Utils = Utils || {};

  /** @type {Function} Custom logger */
  const log = window.console.log.bind(window, 'Main:');

  // Setup Vue loggers for easy debugging
  if (typeof Vue !== 'undefined' && Vue.config && window.location.hostname !== 'www.tiptoe.fr') {
    const prefix = `[Vue@${Vue.version}]`;
    Vue.config.warnHandler = window.console.warn.bind(window, prefix);
    Vue.config.errorHandler = window.console.error.bind(window, prefix);
  }

  /**
   * Returns a function, that, as long as it continues to be invoked, will not
   * be triggered. The function will be called after it stops being called for
   * N milliseconds. If `immediate` is passed, trigger the function on the
   * leading edge, instead of the trailing.
   * @param  {number}    wait       Timer
   * @param  {boolean}   immediate  Launch the function immediately
   * @param  {Function}  func       The function that needs debounce
   * @returns {Function}             A function to bind to the event debounced
   */
  Utils.debounce = function (wait, immediate, func) {
    let timeout;

    return function () {
      const context = this;
      const args = arguments;
      const later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };

  /**
   * Create an ending event for the event triggered
   * @param  {object} e The triggered event's object
   * @returns {undefined}
   */
  Utils.addEndEvent = Utils.debounce(200, false, function (e) {
    $(this).trigger(`${e.type}End`);
  });

  /**
   *
   */
  function APP() {
    if (!(this instanceof APP)) return new APP(options);

    // Global jquery vars
    this.$window = $(window);
    this.$doc = $(document);
    this.$html = $('html');

    // Variables
    this.VIEW_WIDTH = this.$window.innerWidth();
    this.VIEW_HEIGHT = this.$window.innerHeight();
    this.COMPONENTS = [];

    this.IS_LOADED = false;
    this.IS_MOBILE = this.VIEW_WIDTH < 768;
    this.IS_TABLET = this.VIEW_WIDTH >= 768 && this.VIEW_WIDTH <= 1024;
    this.IS_DESKTOP = this.VIEW_WIDTH > 1024;
    this.IS_MOBILE_MENU = this.VIEW_WIDTH < 992;

    this.HAS_DEBUG = 'DEBUG' in window && window.DEBUG;

    this.IS_MOBILE && this.$html.addClass('is-mobile');
    this.IS_TABLET && this.$html.addClass('is-tablet');
    this.IS_DESKTOP && this.$html.addClass('is-desktop');

    // Create ajaxEnd Event
    this.AJAX_END = document.createEvent('Event');
    this.AJAX_END.initEvent('ajaxEnd', true, true);

    let blazySelector = '[data-src]:not(.js-video-iframe)';
    let blazySrc = 'data-src';

    log(this.HAS_DEBUG);

    if (this.HAS_DEBUG) {
      blazySelector += ', [data-twic-src]';
      blazySrc = 'data-twic-src';
    }

    this.lazy = new Blazy({
      selector: blazySelector,
      src: blazySrc,
      successClass: 'is-loaded',
      errorClass: 'has-error',
      offset: window.innerHeight,
      success: function (element) {
        $(this).trigger('blazy:loaded', [element]);
      }.bind(this),
    });

    // Bind events
    this.$window.on({
      load: this.load.bind(this),
      resize: Utils.addEndEvent,
      scroll: Utils.addEndEvent,
      ajaxEnd() {
        console.log('ajaxEnd');
      },
      resizeEnd: function () {
        console.log('resizeEnd');
        this.VIEW_WIDTH = this.$window.innerWidth();
        this.VIEW_HEIGHT = this.$window.innerHeight();

        this.IS_MOBILE = this.VIEW_WIDTH < 768;
        this.IS_TABLET = this.VIEW_WIDTH >= 768 && this.VIEW_WIDTH <= 1024;
        this.IS_DESKTOP = this.VIEW_WIDTH > 1024;
        this.IS_MOBILE_MENU = this.VIEW_WIDTH < 992;

        this.IS_MOBILE && this.$html.addClass('is-mobile');
        this.IS_TABLET && this.$html.addClass('is-tablet');
        this.IS_DESKTOP && this.$html.addClass('is-desktop');
      }.bind(this),
    });

    return this;
  }

  /**
   * After load function
   * @param  {Event} e
   * @returns {void}
   */
  APP.prototype.load = function (e) {
    this.IS_LOADED = true;

    this.lazy.revalidate();

    window.dataLayer = window.dataLayer || [];

    let isScrolling = false;
    let scroll = window.pageYOffset;
    let dampScroll = window.pageYOffset;
    const links = document.querySelectorAll('a[href^="#"]');
    const $obfuscatedLinks = $('.js-obfuscated-link');
    const $footerAccordeons = $('.nav-footer__title');
    const $menuBtn = $('.js-datalayer-menu');

    $menuBtn.on('click', function () {
      const $element = $(this);

      window.dataLayer.push({
        event: 'menu_click',
        entry_category: $element.data('entry-category'),
        entry_name: $element.data('entry-name'),
        entry_destination_url: $element.attr('href')
          ? $element.attr('href')
          : $element.data('href'),
        entry_position: $element.data('entry-position'),
      });
    });

    links.forEach(function (link) {
      link.addEventListener('click', clickHandler.bind(undefined, link));
    });

    $footerAccordeons.on('click', function (event) {
      $(event.currentTarget).parent().toggleClass('show');
    });

    $obfuscatedLinks.on('click', obfuscateLinkClickHandler);

    const read_mores = document.querySelectorAll('.js-read-more');

    for (let i = read_mores.length - 1; i >= 0; i--) {
      new ReadMore(read_mores[i]);
    }

    if (typeof KlaviyoSubscribe !== 'undefined') {
      KlaviyoSubscribe.attachToForms('#tt-klaviyo-footer', {
        success_message: 'Thanks for subscribing! Check your email for a confirmation message.',
        success(e) {
          $('.newsletter__success-footer').addClass('is-visible');

          const formId = $('#tt-klaviyo-footer').find('input[name="g"]').val();
          window.dataLayer = window.dataLayer || [];
          if (
            formId &&
            (window.dataLayer !== undefined || typeof window.dataLayer.push === 'function')
          ) {
            window.dataLayer.push({
              event: 'newsletter',
              form: {
                form_id: formId,
              },
            });
          }

          setTimeout(function () {
            $('.newsletter__success-footer').remove('is-visible');
          }, 2000);
        },
      });
    }

    $(document).on('click', '.woocommerce-message__close', function () {
      hideMessage();
    });

    /**
     * Hide woocommerce-message & errors on click.
     * @returns {void}
     */
    function hideMessage() {
      $('.woocommerce-error').fadeOut(function () {
        $(this).remove();
      });

      $('.woocommerce-message').fadeOut(function () {
        $(this).remove();
      });
    }

    /**
     * Handler for the click event on anchor links
     */
    function clickHandler(link, event) {
      // Prevent default behaviour
      event.preventDefault();

      // Get the target offset
      const target = document.querySelector(link.hash);
      const sizes = target.getBoundingClientRect();
      const max = document.body.offsetHeight - window.innerHeight;
      let top = sizes.top + window.pageYOffset;

      // Make sure to not scroll more than the max scroll allowed
      if (top >= max) {
        top = max;
      }

      // Start the scroll
      start(top);
    }

    /**
     * Redirect obfuscated links
     * @param  Object event
     * @returns void
     */
    function obfuscateLinkClickHandler(event) {
      // Prevent default behaviour
      event.preventDefault();
      window.location.href = event.currentTarget.dataset.href;
    }

    /**
     * Handler for the wheel event
     * Is used to cancel the programmatic scroll animation
     */
    function wheelHandler() {
      if (isScrolling) {
        isScrolling = false;
      }
    }

    /**
     * Start the scroll animation
     * @param {number} target The target scroll
     */
    function start(target) {
      isScrolling = true;
      dampScroll = window.pageYOffset;
      scroll = target;

      // Bind wheel event to stop the animation if
      // the user wants to scroll manually
      window.addEventListener('wheel', wheelHandler, { passive: true });

      // Init the loop
      loop();
    }

    /**
     * Scroll animation end's hook
     */
    function end() {
      window.removeEventListener('wheel', wheelHandler);
    }

    /**
     * Scroll animation's loop
     */
    function loop() {
      if (!isScrolling) {
        return end();
      }

      dampScroll = damp(scroll, dampScroll, 0.09);
      window.scrollTo({ top: dampScroll });

      if (dampScroll === scroll) {
        isScrolling = false;
      }

      return requestAnimationFrame(loop);
    }

    /**
     * Smoothly update a value to reach the given target
     */
    function damp(target, current, speed) {
      const value = current + (target - current) * speed;
      return Math.abs(target - current) < 0.1 ? target : value;
    }
  };

  window.TIPTOE = new APP();
})(window, document, jQuery);
